import { year } from "../../../misc/helpers";

//Common
const common = {
  "common.appOwner": "MMX",
  "common.copyright": `© nWise ${year}`,
  "common.appName": "Web-app",
  "common.loading": "Loading",
  "common.call": "Ring",
  "common.answer": "Svar",
  "common.reject": "Advar",
  "common.callback": "Ring tilbage",
  "common.callagain": "Ring igen",
  "common.yes": "Ja",
  "common.no": "Nej",
  "common.on": "ON",
  "common.off": "AF",
  "common.text": "Tekst",
  "common.abort": "Afbryd",
  "common.delete": "Fjerne",
  "common.cancel": "Afbryd",
  "common.missedcall": "Ubesvaret opkald fra",
  "common.save": "Gem",
  "common.hangup": "Læg på",
  "common.add": "Tilføj til",
  "common.firstname": "Fornavn",
  "common.lastname": "Efternavn",
  "common.sipaddress": "SIP-adresse",
  "common.email": "Email",
  "common.address": "Adresse",
  "common.city": "By",
  "common.zipcode": "Postnummer",
  "common.calling": "Ringer",
  "common.dialer": "Tonval",
  "common.back": "Tilbage",
  "common.hide": "Skjul",
  "common.online": "Online",
  "common.video": "Video",
  "common.audio": "Lyd",
  "common.reset": "Nulstil",
  "common.here": "her",
  "common.username": "Brugernavn",
  "common.password": "Adgangskode",
  "common.send": "Sende",
  "common.password1": "Adgangskode",
  "common.password2": "Gentag adgangskode",
  "common.phone": "Telefon",
  "common.sip": "SIP-adresse",
  "common.mobile": "En bil",
  "common.isdn": "ISDN nummer",
  "common.3gnumber": "3G nummer",
  "common.fax": "Fax",
  "common.username_helptext": "Format",
  "common.email_helptext": "Ugyldig email",
  "common.password1_helptext": "Mellem 6 og 20 tegn",
  "common.password2_helptext": "Adgangskoderne er ikke de samme",
  "common.firstname_helptext": "",
  "common.lastname_helptext": "",
  "common.address_helptext": "",
  "common.zipcode_helptext": "",
  "common.city_helptext": "",
  "common.phone_helptext": "",
  "common.sip_helptext": "",
  "common.mobile_helptext": "",
  "common.isdn_helptext": "",
  "common.3gnumber_helptext": "",
  "common.fax_helptext": "",
  "common.link": "link",
  "common.Link": "Link",
  "common.anonymous": "Anonym",
  "common.edit": "Redigere",
  "common.contact_information": "Detaljer",
  "common.view_message": "Se meddelelsen",
  "common.close_message": "Luk meddelelsen",
  "common.required": "* Obligatorisk felt",
  "common.to_startpage": "Til startside",
  "common.organisation": "Organisation",
};

const toolbar = {
  "toolbar.audiooff": "Lyden er AF",
  "toolbar.audioon": "Lyden er TIL",
  "toolbar.videooff": "Videoen er AF",
  "toolbar.videoon": "Videoen er TIL",
  "toolbar.cameraoff": "Kameraet er AF",
  "toolbar.cameraon": "Kameraet er TIL",
  "toolbar.micoff": "Mikrofonen er AF",
  "toolbar.micon": "Mikrofonen er TIL",
  "toolbar.selfviewoff": "Selvbillede er AF",
  "toolbar.selfviewon": "Selvbillede er TIL",
  "toolbar.hidetext": "Teksten er AF",
  "toolbar.showtext": "Tekst er TIL",
  "toolbar.hidedialpad": "Tastaturet er slået AF",
  "toolbar.showdialpad": "Tastaturet er slået TIL",
  "toolbar.useaudioon": "Ring med lyd er ON",
  "toolbar.useaudiooff": "Ring med lyd er AF",
  "toolbar.usevideoon": "Ring med video er ON",
  "toolbar.usevideooff": "Ring med video er AF",
  "toolbar.usetexton": "Ring med tekst er ON",
  "toolbar.usetextoff": "Ring med tekst er AF",
  "toolbar.more": "Mere",
  "toolbar.hide": "Skjul",
  "toolbar.togglevideo": "Se video",
  "toolbar.toggletext": "Se tekst",
  "toolbar.toSettings": "Gå til siden %indstillinger",
};

const titles = {
  "titles.login": "Log ind",
  "titles.services": "Tjenester",
  "titles.contacts": "Mine kontakter",
  "titles.call": "Ring",
  "titles.history": "Historie",
  "titles.messages": "Beskeder",
  "titles.settings": "Indstillinger",
  "titles.userinformation": "Min profil",
  "titles.log": "Fejlfinde",
  "titles.about": "Oplysninger om systemer",
  "titles.registration": "Registrering",
  "titles.newpassword": "Få en ny adgangskode",
  "titles.resetpassword": "Nulstil adgangskode",
};

//Menu
const menu = {
  "menu.logo": "Til startside",
  "menu.services": "Tjenester",
  "menu.servicesHeadline": "Tjenester",
  "menu.contacts": "Kontakter",
  "menu.mycontacts": "Mine kontakter",
  "menu.call": "Ring",
  "menu.history": "Historisk",
  "menu.messages": "Beskeder",
  "menu.settings": "Indstillinger",
  "menu.logout": "Log ud",
  "menu.userinformation": "Konto",
  "menu.userprofile": "Min profil",
  "menu.log": "Fejlfinde",
  "menu.about": "Oplysninger om systemer",
};

//Login screen
const login = {
  "login.loginanonymous.headline": "Ring uden login",
  "login.loginanonymous": "Log ikke ind",
  "login.headline": "Ring med login",
  "login.login": "Log ind",
  "login.loginfailed": "Login mislykkedes",
  "login.resetpassword": "Glemt din adgangskode?",
  "login.registration": "Vil du tilmelde dig?",
  "login.nowebrtc":
    "Din browser understøtter ikke kommunikation i realtid med lyd og video (WebRTC).",
  "login.debug": "Debugging-tilstand",
  "login.optinalLogin": "",
  "login.optinalLoginLink": "",
  "login.optinalLoginInfo": "",
  "login.optinalLoginInfoLink": "",
  "login.optinalLogin2": "",
  "login.optinalLoginLink2": "",
  "login.handleData": "",
  "login.handleDataLink": "",
  "login.logo.href": "https://nwise.se/",
  "login.loggedin.logo.href": "#/",
};

//Errors
const error = {
  "error.usernameorpassword": "Forkert brugernavn eller adgangskode",
  "error.usernameNotExists": "Brugernavnet eksisterer ikke",
  "error.noservercontact": "Ingen kontakt til serveren",
  "error.accountexpired": "Konto gyldighed er bestået",
  "error.tokenexpired":
    "Godkendelsessessionen er udløbet, skal du logge ind igen",
  "error.tokeninvalid": "Autentificeringstokenet er ugyldigt",
  "error.unknown": "Ukendt fejl",
  "error.unknownsender": "Ukendt afsender",
  "error.unknownsip": "Ukendt SIP",
  "error.notextsent": "Ingen tekst blev sendt",
  "error.acquiremedia":
    "Du kan ikke foretage opkald med lyd / video, medmindre du har valgt dette på installationssiden.",
  "error.cantcall":
    "Du kan ikke foretage opkald, når du ikke er i kontakt med systemet",
  "error.cantcall_without_media":
    "Du kan ikke foretage opkald uden lyd, video eller tekst",
  "error.404": "404 - Den side, du forsøger at se, findes ikke",
  "error.unsupportedbrowser":
    "Din webbrowser understøttes i øjeblikket ikke. Brug en anden webbrowser.",
  "error.browseroutofdate":
    "Din webbrowser er forældet. Opdater den til den nyeste version for at bruge applikationen.",
};

//User settings
const settings = {
  "settings.white": "Hvid",
  "settings.lightgrey": "Lysegrå",
  "settings.darkgrey": "Mørk grå",
  "settings.black": "Sort",
  "settings.yellow": "Gul",
  "settings.blue": "Blå",
  "settings.red": "Rød",
  "settings.green": "Grøn",
  "settings.purple": "Lilla",
  "settings.orange": "Orange",
  "settings.pink": "Rosa",
  "settings.helvetica": "Helvetica",
  "settings.times": "Times New Roman",
  "settings.arial": "Arial",
  "settings.trebuchet": "Trebuchet MS",
  "settings.lucida": "Lucida Sans Unicode",
  "settings.verdana": "Verdana",
  "settings.comicsans": "Comic Sans",
  "settings.couriernew": "Courier New",
  "settings.sidebyside": "Side ved side",
  "settings.overunder": "Over og under",
  "settings.one": "Fælles tekstfelt",
  "settings.smartphone": "Smartphone",
  "settings.bell": "Klokke",
  "settings.marimba": "Marimba",
  "settings.glas": "Glas",
  "settings.classic": "Klassisk",
  "settings.settings": "Indstillinger",
  "settings.text": "Tekst",
  "settings.font": "Skrifttyper",
  "settings.fontsize": "Størrelse",
  "settings.textboxlayout": "Layout for tekstfelter",
  "settings.mycolors": "Mit tekstfelt",
  "settings.incomingcolors": "Indgående tekstfelt",
  "settings.sharedcolors": "Fælles tekstfelt",
  "settings.textcolors": "Tekstfarve",
  "settings.backgroundcolors": "Baggrundfarve",
  "settings.preview": "Eksempel",
  "settings.loremipsum":
    "Lorem ipsum dolor sit amet, consectetur adipiscing Elit, sed Tempor og vitalitet, så arbejdskraft og sorg, nogle vigtige ting at gøre eiusmod.",
  "settings.previewmytext": "Min tekst",
  "settings.previewincomingtext": "Indgående tekst",
  "settings.previewbothtext": "Min tekst, Indgående tekst",
  "settings.incomingcalls": "Indgående opkald",
  "settings.ringsignal": "Ringetone",
  "settings.messagebox": "Besked",
  "settings.autoanswer": "Brug tekstbesked, når du ikke reagerer",
  "settings.autoanswermessage": "Budskabet",
  "settings.duringcalls": "I samtale",
  "settings.colors": "Farver",
  "settings.textformat": "Tekst",
  "settings.media": "Media",
  "settings.audio": "Lyd",
  "settings.video": "Video",
  "settings.ringtone": "Ringetone",
  "settings.mediamail": "Beskeder",
  "settings.about": "Systemoplysninger",
  "settings.logout": "Log ud",
  "settings.logout.anonymous": "Log ud",
  "settings.saved": "Indstillingerne er blevet gemt",
  "settings.media_explanation":
    "Bestemm hvilken måde du skal ringe til. Hvis en indstilling er tændt, kan du altid slukke for et opkald, men hvis det er slukket, kan du ikke tænde det i et opkald.",
  "settings.useaudio": "Ring med lyd",
  "settings.usevideo": "Ring med video",
};

//Messages
const messages = {
  "messages.messages": "Beskeder",
  "messages.unreadmessages": "Ulæst",
  "messages.readmessages": "Læse",
  "messages.nomessages": "Du har ingen beskeder",
  "messages.deleteallread": "Slet alle læste meddelelser",
  "messages.deleteallreadconfirm": "Slet alle læste meddelelser?",
  "messages.messageAlert": "Beskeden er blevet slettet",
};

//Contacts
const contacts = {
  "contacts.contacts": "Mine kontakter",
  "contacts.addcontact": "Tilføj kontakt",
  "contacts.deletecontact": "Fjern stikket",
  "contacts.nosipgiven": "Udfyld venligst en SIP-adresse til kontakten",
};

//Call screen
const call = {
  "call.placeholder": "Indtast nummer / navn her",
  "call.incomingtext": "Indgående tekst",
  "call.outgoingtext": "Udgående tekst",
  "call.incoming": "Indgående opkald fra",
  "call.hiddennumber": "Skjult nummer",
  "call.endedcall": "Afsluttede samtalen",
  "call.yourejected": "Du afviste opkaldet",
  "call.noanswer": "Intet svar",
  "call.rejected": "Kunne ikke svare i øjeblikket",
  "call.notfound": "Kan ikke nås",
  "call.toolongtext": "\n<Teksten er for lang. Maks. 1000 tegn>\n",
  "call.notificationbody": "Klik her for at svare",
  "call.writeHere": "Skriv her...",
  "call.receiveHere": "Her er den indgående tekst",
  "call.establishing": "Etablering af opkald...",
};

//History screen
const history = {
  "history.history": "Historisk",
};

//Reset password
const resetpassword = {
  "resetpassword.processing": "Behandling ...",
  "resetpassword.completed": "Password reset er afsluttet",
  "resetpassword.email_or_username": "Email eller brugernavn",
  "resetpassword.title": "Nulstil adgangskode",
  "resetpassword.explanation":
    "Indtast din e-mail eller dit brugernavn og send et link til den givne e-mail eller den e-mail, der er knyttet til brugernavnet. Via linket kan du nulstille dit kodeord.",
  "resetpassword.explanation_complete":
    "Du vil snart modtage en email med yderligere instruktioner.",
  "resetpassword.invalid_link": "Ugyldig nulstillingslink",
  "resetpassword.password_changed": "Dit kodeord er ændret",
  "resetpassword.enter_new_password": "Indtast ny adgangskode",
  "resetpassword.button_reset": "Gem",
  "resetpassword.password": "Adgangskode",
  "resetpassword.password_repeat": "Gentag adgangskode",
  "resetpassword.password_requirement":
    "Adgangskoden skal være mellem 6 og 20 tegn",
  "resetpassword.error":
    "Det var ikke muligt at nulstille adgangskoden. Prøv igen eller kontakt din administrator",
  "resetpassword.link_too_old": "linket er for gammel",
};

const registration = {
  "registration.error":
    "Det var ikke muligt at afslutte registreringen. Prøv igen eller kontakt din administrator.",
  "registration.title": "Registrering",
  "registration.processing": "Behandling ...",
  "registration.not_enabled": "Registrering er ikke aktiveret.",
  "registration.completed_headline": "Du er blevet registreret",
  "registration.completed": "Din registrering er afsluttet.",
  "registration.completed_link": "/",
  "registration.username_exists":
    "Brugernavnet er allerede registreret. Indtast venligst et andet brugernavn.",
  "registration.email_exists":
    "E-mailen er allerede registreret. Indtast venligst en anden email.",
  "registration.sip_exists":
    "SIP-adressen er allerede registreret. Indtast venligst en anden SIP-adresse.",
  "registration.license1": "Ja, jeg har læst",
  "registration.license_link_text":
    "Oplysninger om behandling af personoplysninger",
  "registration.license2": "og acceptere betingelserne herfor",
  "registration.licenselink": "https://nwise.se/om-oss/",
  "registration.info": " ",
  "registration.check_checkbox":
    "Accept vilkårene, hvis du ønsker at tilmelde dig",
};

const changeuser = {
  "changeuser.title": "Rediger konto",
  "changeuser.titlePassword": "Skift adgangskode",
  "changeuser.newPassword": "Ny adgangskode",
  "changeuser.error":
    "Det var ikke muligt at opdatere kontoen. Prøv igen, eller kontakt din administrator.",
  "changeuser.complete": "Konto opdateret",
  "changeuser.processing": "Behandling ...",
  "changeuser.username_exists":
    "Brugernavnet er allerede registreret. Indtast venligst et andet brugernavn.",
  "changeuser.email_exists":
    "E-mailen er allerede registreret. Indtast venligst en anden email.",
  "changeuser.sip_exists":
    "SIP-adressen er allerede registreret. Indtast venligst en anden SIP-adresse.",
};

const network = {
  "network.networkError":
    "Der opstod et problem under forbindelse til serveren",
  "network.offline": "Offline",
};

const accessibility = {
  "accessibility.darktheme": "Mørkt tema",
  "accessibility.originaltheme": "Oprindelige tema",
};

const about = {
  "about.user": "Brugernavn",
  "about.sip": "SIP-adresse",
  "about.server": "Server IP",
  "about.version": "Version",
  "about.browser": "Browser",
  "about.browserversion": "Browser version",
  "about.os": "Operativsystem",
};

const aria = {
  "aria.mainmenu": "Hovedmenuen",
  "aria.submenu_contacts": "Undermenuen i Kontakter",
  "aria.submenu_account": "Konto undermenu",
  "aria.selected_page": "Dit side",
  "aria.back_button": "Slet det sidste tegn",
  "aria.accept_terms": "Accepter vilkår",
  "aria.link_sound_video": "Gå til lyd- og videoindstillingerne",
  "aria.selfview": "Video on dig selv",
  "aria.in-call": "I opkald",
};

const da = {
  ...common,
  ...toolbar,
  ...titles,
  ...login,
  ...error,
  ...settings,
  ...menu,
  ...messages,
  ...contacts,
  ...call,
  ...history,
  ...resetpassword,
  ...registration,
  ...changeuser,
  ...network,
  ...accessibility,
  ...about,
  ...aria,
};

export default da;






// WEBPACK FOOTER //
// ./src/branding/default/language/da.js